export const en_GB = {
  translation: {
    personalDetails: {
        heading: "Check your finance eligibility",
        aboutYou: "About you",
        emailDisclaimer: "We won’t use this to contact you unless you ask us to.",
        dobHelperText: "e.g. 31 12 2002",
        incomePrompt: "Please let us know your total annual income",
        softCheckText: "Soft credit search, no impact on your credit score. No obligation to finance with us.",
        importantInfoHeader: "Important Information",
        submissionAgreement: "By submitting your information to check your eligibility, you consent to the processing of your data to perform the check, and you agree to our",
        importantInfo: "The Ford Credit eligibility check is provided using an Experian Soft Check. Ford Credit is a trading style of FCE Bank plc." +
            "\nYour likelihood of eligibility for finance with Ford Credit is an indication only, it does not guarantee finance approval.",
        errorSectionFieldHeading: "Let's fix a couple of things.",
        errorSectionSubmitHeading: "We can’t check your eligibility right now, please try later",
        errorSectionBody: {
            field: "Check your {{errorFields}} and then try again.",
            submit: "We apologise for this temporary system error."
        },
        continueButton: "Check Your Eligibility",
        labels: {
            firstName: "First name",
            lastName: "Last name",
            dobDay: "Day",
            dobMonth: "Month",
            dobYear: "Year",
            dobCombined: "Date of birth", 
            email: "Email address",
            income: "Total annual income",
        },
        error: {
            firstNameRequired: "First name is required",
            invalidChars: "{{- fieldName}} should contain only letters, spaces, hyphens, and apostrophes",
            lastNameRequired: "Last name is required",
            emailInvalid: "Email format is invalid",
            emailRequired: "Email address is required",
            dobRequired: "Date of birth is required",
            dobMissingFields: "Date of birth must include a {{fields}}",
            dobDayInvalid: "Day must be between 1 and 31", 
            dobMonthInvalid: "Month must be between 1 and 12", 
            dobYearInvalid: "Year must be valid", 
            dobInvalidDate: "Date of birth must be a real date",
            dobInFuture: "Date of birth must be in the past",
            dobMinAge: "You must be at least 18 years old",
            incomeRequired: "Income is required",
            mustBeANumber: "Income must be a valid number",
        },
    },
    addressDetails: {
        heading: "Please enter your current address",
        previousAddressHeading: "Please enter your previous address",
        enterYourAddress: "Enter your address manually",
        backToAddressSearch: "Back to address search",
        flatNumber: "Flat number",
        houseNumber: "House number",
        houseName: "House name",
        street: "Street",
        townCity: "Town/City",
        county: "County",
        postcode: "Postcode",
        whenDidYouMove: "When did you move to this address?",
        enterYourPostcode: "Enter your postcode",
        selectYourAddress: "Select your address",
        month: "Month",
        year: "Year",
        selectedAddress: "Selected Address",
        searchAnotherAddress: "Search for another address",
        currentAddressDetails: "current address details",
        previousAddressDetails: "previous address details",
        placeholders: {
            addressSelect: "Please select your address",
        },
        error: {
            flatOrHouseNumberOrNameRequired: "Either flat number, house number, or house name is required",
            streetRequired: "Street is required",
            townCityRequired: "Town/City is required",
            postcodeRequired: "Postcode is required",
            postcodeInvalid: "Postcode format is invalid",
            countyRequired: "County is required",
            invalidChars: "{{- fieldName}} should contain only letters, spaces, hyphens, and apostrophes",
            invalidChars1: "{{- fieldName}} should contain only letters, numbers, and spaces",
            invalidChars2: "{{- fieldName}} should contain only letters, numbers, spaces, hyphens, and apostrophes",
            monthRequired: "Month is required",
            yearRequired: "Year is required",
            postcodeLookupNotFound: "Enter a valid postcode.",
            postcodeLookupError: "Enter a valid postcode.",
        },
    },
    creditDecision : {
        success: {
            resultsHeader: ", your results are in!",
            resultsBody: "Based on what you've told us, you're likely to be eligible for low-rate finance with Ford Credit.",
            aprRepresentative: "% APR representative*",
            aprDisclaimer: "APRs vary by vehicle and contract length, so it's worth checking out our promotions to see what you might be eligible for.",
            dealerCardHeading: "Speak with a Dealer",
            dealerCardBody: "Your next Ford might be closer than you think.",
            dealerCardBody1: "Speak with a Ford dealer to find out what's available.",
            speakToDealerButton: "Speak with a Dealer",
            financePromotionsButton: "Finance Promotions",
            promotionsHeading: "Browse our latest promotions",
            promotionsDescription: "Explore what's currently available and check what you might be eligible for.",
            promotionsHeroTitle: "Current Finance Promotions",
            explorePromotionsButton: "Explore Finance Promotions"
        },
        declined: {
            resultsHeader: "We couldn't confirm your eligibility result.",
            subHeading: "We weren't able to show your finance eligibility result based on the information you've provided today, " +
                "but there may be other options to explore.",
            exploreOtherOptions: "To find out what might be available to you, speak to your local Ford Dealer.",
            aprDisclaimer: "Our APRs may change based on the car and finance plan you choose. Take a look at our latest promotions to see what's on offer and what you might be eligible for.",
            speakToDealerButton: "Speak with a Dealer",
            exploreRangeButton: "Explore Ford Vehicles"
        },
        links: {
            contactDealerApproved: {
                url: "{{baseUrl}}/shop/finance-eligibility-check-success",
                openNewTab: true
            },
            contactDealerReferred: {
                url: "{{baseUrl}}/shop/finance-eligibility-check-referred",
                openNewTab: true
            },
            promotions: {
                url: "https://buy.ford.co.uk/offers?channel=b2c",
                openNewTab: false
            },
            range: {
                url: "{{baseUrl}}/cars",
                openNewTab: false
            }
        },
        importantInfo: "The Experian Soft Search hasn't affected your credit rating and there is no obligation to finance with Ford Credit."
    },
    privacyPolicy: {
      label: "Privacy Policy",
      linkProps: {
        url: "https://www.ford.co.uk/content/dam/guxeu/uk/documents/home/footer/DOC-ford_credit_fce_bank_plc_finance_application_privacy_notice.pdf",
        openNewTab: true
      }
    },
    general: {
        importantInfoLabel: "Important Information",
        openNewTabAriaLabel: "(opens in new tab)"
    },
    submittingSpinner: {
        heading: "Checking your eligibility",
        duration: "This can take a minute or so",
        instruction: "Please don’t refresh the page",
        ariaLabel: "Submitting...",
    },
    pageTitle: {
        eligibilityDecision: "Eligibility Decision"
    },
    maintenance: {
        title: "Eligibility check unavailable",
        body: "We're carrying out routine maintenance and can't run an eligibility check right now.",
        tryAgain: "Please try again later.",
        prompt: "Don't want to wait?",
        promotions: "You can still browse our current Ford Credit promotions.",
        explorePromotionsButton: "Explore Finance Promotions",
        link: "https://buy.ford.co.uk/offers?channel=b2c"
    }
  },
};
